function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import propEq from 'ramda/src/propEq';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { ActiveSubtenantsSelector } from 'invision-core/src/components/subtenants/subtenants.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { CurrentBusinessUnitSelector } from 'invision-core/src/components/session/businessunit.selectors';
import { fetchCodeTypes, fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { LanguagesForCurrentBusinessUnitSelector, MetadataCodeLoadedSelector, MetadataOptionsForCodeValuesSelector, MetadataOptionsForCodeValuesWithoutPlaceholderSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { setCustomerCategory } from '../../../../reducers/actions/customer.actions';
import { clearQuoteAndSetSelectedOffer, updateCustomerInfoEditCopy } from '../../../../reducers/actions/new.connect.wizard.actions';
import { CustomerInfoSelector, CreateCountryCurrencyValueOptions, DefaultCountryCurrencySelector, EditCustomerInfoSelector } from '../../../../reducers/selectors/new.connect.wizard.selectors';
import { CustomerTypeFilteredSelector } from '../../../createCustomerPopup/customer.form.dropdown.selectors';
import { SelectedContractSelector } from '../../../../reducers/selectors/contract.selectors';
import { CurrentBusinessUnitHasSubtenants } from '../../../../reducers/selectors/subtenant.selectors';
import { StateRegionProvinceValueOptions } from '../../newConnectWizard/new.connect.wizard.selectors';
import { IsFetchingSelector } from '../../../../reducers/selectors/offering.order.selectors';
import { loadSubscriberRequirements } from '../../../../reducers/helpers/subscriber.requirements.actions.helper';
import { PostalCodeSelector } from '../../../../reducers/selectors/customer.addresses.selectors';
import { setAddressData } from '../../../../reducers/actions/customer.addresses.actions';
import { resetSearchCriteria, setSearchCriteriaAndSearchContracts } from '../../../../reducers/actions/contracts.list.actions';
import { CUSTOMER_CATEGORY, CustomerCategories } from '../../../createCustomerPopup/create.customer.popup.constants';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../../../customer/addresses/addresses.constants';
import { setSelectedContract } from '../../../../reducers/actions/contract.details.actions';
import { IsAddressMandatoryInCreditCheckSelector, MarkMandatoryCreditCheckFieldsDisabledSelector } from '../../../../reducers/selectors/credit.check.selectors';
var ServiceabilityController = /*#__PURE__*/function () {
  function ServiceabilityController($ngRedux, uiNotificationService, $timeout, $q) {
    _classCallCheck(this, ServiceabilityController);
    Object.assign(this, {
      addressFormModel: {},
      addressPayload: {},
      $ngRedux: $ngRedux,
      $q: $q,
      $timeout: $timeout,
      uiNotificationService: uiNotificationService,
      onAddressFormUpdate: this.onAddressFormUpdate.bind(this)
    });
  }
  return _createClass(ServiceabilityController, [{
    key: "isResidentialSelected",
    value: function isResidentialSelected() {
      return this.category.id === CUSTOMER_CATEGORY.RESIDENTIAL;
    }
  }, {
    key: "mapStateToTarget",
    value: function mapStateToTarget(store) {
      return {
        addressCountries: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.AddressCountry, store),
        addressStates: StateRegionProvinceValueOptions(store),
        addressStateTypesLoaded: MetadataCodeLoadedSelector(CODES.AddressStateProvinceRegion, store),
        countryCurrencies: CreateCountryCurrencyValueOptions(store),
        currentBusinessUnit: CurrentBusinessUnitSelector(store),
        currentBusinessUnitHasSubtenants: CurrentBusinessUnitHasSubtenants(store),
        currentSubtenants: ActiveSubtenantsSelector(store),
        customerInfo: CustomerInfoSelector(store),
        customerTypeFilteredOptions: CustomerTypeFilteredSelector(store),
        defaultCountryCurrency: DefaultCountryCurrencySelector(store),
        editCustomerInfo: EditCustomerInfoSelector(store),
        isAddressCountriesLoaded: MetadataCodeLoadedSelector(CODES.AddressCountry, store),
        isAddressMandatoryInCreditCheck: IsAddressMandatoryInCreditCheckSelector(store),
        isCountryCurrenciesLoaded: MetadataCodeLoadedSelector(CODES.CountryCurrency, store),
        isFetchingAvailableOffers: IsFetchingSelector(store),
        languages: LanguagesForCurrentBusinessUnitSelector(store),
        markMandatoryCreditCheckFieldsDisabled: MarkMandatoryCreditCheckFieldsDisabledSelector(store),
        personTitleOptions: MetadataOptionsForCodeValuesSelector(CODES.PersonTitle, store),
        postalCode: PostalCodeSelector(store),
        selectedContract: SelectedContractSelector(store),
        subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
        subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store)
      };
    }
  }, {
    key: "openContractPopup",
    value: function openContractPopup() {
      var _this = this;
      this.contractDialogOpened = true;
      this.$timeout(function () {
        _this.contractPopupApi.open();
      });
    }
  }, {
    key: "closeContractPopup",
    value: function closeContractPopup() {
      this.contractPopupApi.close();
      this.contractDialogOpened = false;
    }
  }, {
    key: "successContractPopup",
    value: function successContractPopup(selectedContract) {
      this.contractPopupApi.close();
      this.contractDialogOpened = false;
      this.actions.setSelectedContract(selectedContract);
      this.selectedContractId = selectedContract.Id;
    }
  }, {
    key: "clearSelectedContract",
    value: function clearSelectedContract() {
      this.selectedContractId = null;
      this.actions.setSelectedContract(null);
    }
  }, {
    key: "setRequirements",
    value: function setRequirements() {
      this.requirements = this.isResidentialSelected() ? this.state.subscriberRequirements : this.state.subscriberCategoryRequirements;
    }
  }, {
    key: "onAddressFormUpdate",
    value: function onAddressFormUpdate(addressFormModel) {
      this.addressFormModel.addressLine1 = addressFormModel.addressLine1;
      this.addressFormModel.addressLine2 = addressFormModel.addressLine2;
      this.addressFormModel.city = addressFormModel.city;
      this.addressFormModel.stateRegionProvince = addressFormModel.stateRegionProvince;
      this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
      if (addressFormModel.country && addressFormModel.country !== this.addressFormModel.country) {
        this.addressFormModel.country = addressFormModel.country;
        this.handleChangeFormCountry();
      } else {
        this.updateCustomerInfoEditCopy();
      }
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        clearQuoteAndSetSelectedOffer: clearQuoteAndSetSelectedOffer,
        fetchCodeTypes: fetchCodeTypes,
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        loadSubscriberRequirements: loadSubscriberRequirements,
        resetSearchCriteria: resetSearchCriteria,
        setAddressData: setAddressData,
        setCustomerCategory: setCustomerCategory,
        setSearchCriteriaAndSearchContracts: setSearchCriteriaAndSearchContracts,
        setSelectedContract: setSelectedContract,
        updateCustomerInfoEditCopy: updateCustomerInfoEditCopy
      };
      this.contractPopupApi = null;
      this.contractPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.contractPopupApi = event.api;
        }
      };
      this.contractTermsConditionsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.contractTermsConditionsPopupApi = event.api;
        }
      };
      this.openContractTermsConditionsPopup = function () {
        _this2.contractTermsConditionsPopupOpened = true;
        _this2.$timeout(function () {
          _this2.contractTermsConditionsPopupApi.open();
        });
      };
      this.handleCloseContractTermsConditionsPopup = function () {
        _this2.contractTermsConditionsPopupApi.close();
        _this2.contractTermsConditionsPopupOpened = false;
      };
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.actions.resetSearchCriteria();
      this.isLoaded = false;
      this.requirements = {};
      this.selectedContractId = null;
      this.actions.loadSubscriberRequirements().then(function () {
        _this2.setRequirements();
        _this2.isLoaded = true;
      });
      this.formMaxLengthValidation = ADDRESS_FORM_FIELD_MAX_LENGTH;
      this.customerCategories = CustomerCategories();
      this.category = this.state.customerInfo.Category === undefined ? this.customerCategories[0] : this.customerCategories.find(propEq(this.state.customerInfo.Category, 'id'));
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
      this.CoreLocaleKeys = CoreLocaleKeys;
      // this is not best practice, but due to the BU reloading on security invalidation we needed to stop the languages options from empting out.
      this.languageOptions = this.state.languages.slice();
      this.actions.setCustomerCategory(this.category.id);
      this.actions.updateCustomerInfoEditCopy(this.state.customerInfo);
      this.updateCustomerInfoEditCopy = function () {
        var addressUpdated = false;
        if (_this2.addressFormModel.country !== _this2.addressPayload.Country) {
          addressUpdated = Object.values(_this2.addressPayload).length;
          if (_this2.addressFormModel.country) {
            _this2.addressPayload.Country = _this2.addressFormModel.country;
          }
          _this2.actions.setAddressData(_this2.addressPayload);
        }
        _this2.setRequirements();
        _this2.actions.updateCustomerInfoEditCopy({
          addressLine1: _this2.addressFormModel.addressLine1,
          addressLine2: _this2.addressFormModel.addressLine2,
          Category: _this2.category.id,
          city: _this2.addressFormModel.city,
          CompanyName: _this2.category.id === CUSTOMER_CATEGORY.COMMERCIAL ? _this2.CompanyName : '',
          country: _this2.addressFormModel.country,
          FirstName: _this2.category.id === CUSTOMER_CATEGORY.RESIDENTIAL ? _this2.FirstName : '',
          HomeCountry: _this2.addressFormModel.country,
          Language: _this2.language,
          LastName: _this2.category.id === CUSTOMER_CATEGORY.RESIDENTIAL ? _this2.LastName : '',
          postalCode: _this2.addressFormModel.postalCode,
          PreferredName: _this2.preferredName,
          PreferredTaxReportingCurrency: addressUpdated ? null : _this2.state.editCustomerInfo.PreferredTaxReportingCurrency,
          stateRegionProvince: _this2.addressFormModel.stateRegionProvince,
          SubscriberCurrency: _this2.currency,
          SubscriberTypeCode: _this2.type ? _this2.type.value : '',
          SubtenantId: _this2.subtenant ? _this2.subtenant.Id : null,
          Title: _this2.title
        });
      };
      this.handleChangeFormCountry = function () {
        // This function sets the HomeCountry in the REDUX store which correctly populates *this.state.countryCurrencies*
        // Hence, we end up making 2 *this.updateCustomerInfoEditCopy()* calls when the Country is changed.
        _this2.updateCustomerInfoEditCopy();
        if (_this2.state.isCountryCurrenciesLoaded && _this2.state.countryCurrencies) {
          _this2.updateCountryCurrencyField();
        } else {
          _this2.uiNotificationService.error(i18n.translate(CustomerCareLocaleKeys.CURRENCY_NOT_FOUND), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
      };
      this.handleChangeFormCurrency = function () {
        _this2.actions.clearQuoteAndSetSelectedOffer();
        _this2.updateCustomerInfoEditCopy();
      };
      this.updateCountryCurrencyField = function () {
        if (_this2.state.countryCurrencies.find(function (currencyOption) {
          return currencyOption.value === _this2.state.editCustomerInfo.SubscriberCurrency;
        })) {
          _this2.currency = _this2.state.editCustomerInfo.SubscriberCurrency;
        } else {
          _this2.currency = _this2.state.defaultCountryCurrency ? _this2.state.defaultCountryCurrency.Value : _this2.state.countryCurrencies[0].value;
        }
        if (_this2.currency && _this2.state.customerInfo.SubscriberCurrency !== _this2.currency) {
          _this2.handleChangeFormCurrency();
        } else {
          _this2.updateCustomerInfoEditCopy();
        }
      };
      this.persistData();
      if (!this.type && this.customerTypeOptions && this.customerTypeOptions[this.category.id] && this.customerTypeOptions[this.category.id].length) {
        this.cloneCustomerTypes();
      }
      this.onUpdateSubcriberCategoryModel = function () {
        _this2.subtenant = null;
        _this2.actions.setCustomerCategory(_this2.category.id);
        _this2.cloneCustomerTypes();
        _this2.updateCustomerInfoEditCopy();
      };
      this.onUpdateSubcriberTypeModel = function () {
        if (_this2.type) {
          _this2.updateCustomerInfoEditCopy();
        }
      };
      this.onlyOneCountryAndOneCurrency = function () {
        return _this2.state.addressCountries.length === 1 && _this2.state.countryCurrencies.length === 1;
      };

      //Object assign below is if coming from previous step
      Object.assign(this.addressFormModel, this.state.customerInfo);
      this.addressFormModel.country = this.state.customerInfo.HomeCountry ? this.state.customerInfo.HomeCountry : this.state.currentBusinessUnit.defaultCountry;
      this.language = this.state.customerInfo.Language ? this.state.customerInfo.Language : this.state.currentBusinessUnit.defaultLanguage;
      if (this.state.isCountryCurrenciesLoaded && this.state.isAddressCountriesLoaded) {
        this.handleChangeFormCountry();
      } else {
        var promises = [];
        //Added below back in due to country-currency dependency specifically oneCountryOneCurrency
        if (!this.state.isAddressCountriesLoaded) {
          promises.push(this.actions.fetchCodeTypes(CODES.AddressCountry));
        }
        if (!this.state.isCountryCurrenciesLoaded) {
          promises.push(this.actions.fetchCodeTypesThunk(CODES.CountryCurrency));
        }
        this.$q.all(promises).then(function () {
          _this2.handleChangeFormCountry();
        });
      }
      if (!this.state.addressStateTypesLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressStateProvinceRegion);
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changeObj) {
      if (this.state && changeObj.updateStateValues && changeObj.updateStateValues.previousValue !== changeObj.updateStateValues.currentValue) {
        this.persistData();
      }
      if (changeObj.customerTypeOptions && !changeObj.customerTypeOptions.isFirstChange() && changeObj.customerTypeOptions.currentValue !== changeObj.customerTypeOptions.previousValue) {
        this.cloneCustomerTypes();
      }
    }
  }, {
    key: "cloneCustomerTypes",
    value: function cloneCustomerTypes() {
      this.customerTypes = this.customerTypeOptions[this.category.id];
      if (this.customerTypes) {
        var selectedCustomerType = this.customerTypes.find(propEq(this.state.customerInfo.SubscriberTypeCode, 'value'));
        if (this.state.customerInfo.SubscriberTypeCode && selectedCustomerType) {
          this.type = selectedCustomerType;
        } else {
          this.type = this.customerTypes.find(propEq(true, 'default')) || this.customerTypes[0];
        }
      }
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.state.isAddressMandatoryInCreditCheck && this.state.markMandatoryCreditCheckFieldsDisabled;
    }
  }, {
    key: "persistData",
    value: function persistData() {
      //This will get triggered after creditCheckModal is successful
      this.FirstName = this.state.customerInfo.FirstName;
      this.LastName = this.state.customerInfo.LastName;
      this.CompanyName = this.state.customerInfo.CompanyName;
      this.currency = this.state.customerInfo.SubscriberCurrency;
      this.language = this.state.customerInfo.Language;
      this.preferredName = this.state.customerInfo.PreferredName;
      this.subtenant = this.getSubtenant();
      this.selectedContractId = this.state.selectedContract ? this.state.selectedContract.Id : null;
      this.title = this.state.customerInfo.Title;
      this.onAddressFormUpdate({
        addressLine1: this.state.customerInfo.addressLine1,
        addressLine2: this.state.customerInfo.addressLine2,
        city: this.state.customerInfo.city,
        country: this.state.customerInfo.country,
        stateRegionProvince: this.state.customerInfo.stateRegionProvince,
        postalCode: this.state.customerInfo.postalCode
      });
    }
  }, {
    key: "getSubtenant",
    value: function getSubtenant() {
      var _this3 = this;
      return this.state.customerInfo.SubtenantId ? this.state.currentSubtenants.find(function (subtenant) {
        return subtenant.Id.Value === _this3.state.customerInfo.SubtenantId.Value;
      }) : null;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./serviceability.html'),
  controller: ServiceabilityController,
  controllerAs: 'serviceabilityController',
  require: {
    wizardForm: '^form'
  },
  bindings: {
    contracts: '<',
    updateStateValues: '<',
    customerTypeOptions: '<',
    isNewConnect: '<'
  }
};